import { createAction } from '@reduxjs/toolkit'

import { stateName } from '../constants'

export const selectCreditCardRequest = createAction<{ creditCardId: string }>(
  `${stateName}/selectCreditCardRequest`,
)
